import React from 'react'

export const LogoContainer =(props) => {
    return  <div className="nw-header--logo-container">
    <img
    src={"Images/icon-logo.svg"}
    alt="Networth Logo"
  />
  </div>
}